import Component from './password.vue'
export default Component
